const fin_totalcost_reducer = (state = 0.00, action) => {
	switch(action.type) {

		case 'UPDATEDFINTOTALCOST':
			return typeof action.payload !== "undefined" ? action.payload : 0.00;

		default:
			return state;
	}
}

export default fin_totalcost_reducer;